import api from "./api";

// Bitacora de cambios (tabla bitacoracambio): que registro cada usuario en
// cada tabla y campo, con el valor antes y despues. Es de solo lectura, no hay
// alta ni borrado.
//
// Los filtros se mandan solo cuando tienen valor: un campo vacio en la cadena
// de consulta haria que el API no pudiera leer la fecha como DateTime.

export const getsBitacoraCambio = async (filtros = {}) => {
    const parametros = new URLSearchParams();
    const agregar = (nombre, valor) => {
        if (valor !== null && valor !== undefined && valor !== "") {
            parametros.append(nombre, valor);
        }
    };

    agregar("tabla", filtros.tabla);
    agregar("campo", filtros.campo);
    agregar("llaves", filtros.llaves);
    agregar("usuario", filtros.usuario);
    agregar("operacion", filtros.operacion);
    agregar("limite", filtros.limite);
    agregar("fechaInicio", filtros.fechaInicio);
    agregar("fechaFin", filtros.fechaFin);

    const response = await api.get("/BitacoraCambio/GetsBitacoraCambio?" + parametros.toString());

    return response.data.data;
}

export default { getsBitacoraCambio };
